import './PuzzleLoading.css';

interface PuzzleLoadingProps {
    mode?: 'classic' | 'flip' | 'bridge' | 'swipe';
    message?: string;
}

export function PuzzleLoading({ mode = 'classic', message = 'Loading puzzle...' }: PuzzleLoadingProps) {
    // Determine icon and styling based on mode
    let iconSrc: string;
    let iconAlt: string;
    let modeClass: string;
    let hint: string;

    switch (mode) {
        case 'flip':
            iconSrc = '/static/arrows.png';
            iconAlt = 'Flip Mode';
            modeClass = 'mode-flip';
            hint = 'Find all the hidden words!';
            break;
        case 'bridge':
            iconSrc = '/static/bridge.png';
            iconAlt = 'Bridge Mode';
            modeClass = 'mode-bridge';
            hint = 'Build the semantic bridge!';
            break;
        case 'swipe':
            iconSrc = '/static/swipe.png';
            iconAlt = 'Swipe Mode';
            modeClass = 'mode-swipe';
            hint = 'Swipe to sort the words!';
            break;
        default:
            iconSrc = '/static/thermometer.png';
            iconAlt = 'Classic Mode';
            modeClass = 'mode-classic';
            hint = 'Guess the secret word!';
    }

    return (
        <div className={`puzzle-loading ${modeClass}`}>
            <div className="puzzle-loading-content">
                {/* Animated game icon - uses CSS animation for smooth continuous motion */}
                <div className="puzzle-loading-icon">
                    <img
                        src={iconSrc}
                        alt={iconAlt}
                        className="puzzle-loading-icon-img"
                    />
                </div>

                {/* Spinner */}
                <div className="puzzle-loading-spinner">
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring delay-1"></div>
                    <div className="spinner-ring delay-2"></div>
                </div>

                {/* Message */}
                <p className="puzzle-loading-message">{message}</p>

                {/* Subtle hint */}
                <p className="puzzle-loading-hint">{hint}</p>
            </div>
        </div>
    );
}

export default PuzzleLoading;
